import React, { useState } from 'react'
import { connect } from 'react-redux'
import { openModal, closeModal } from '../../../../action/positioned-modal-state'
import './index.scss'
import strings from './strings.json'


const SubInfo = props => {
  const [planDuration, setPlanDuration] = useState(7),
    { closeModal } = props,
    makeColumn = name => {
      const columnStrings = strings[name],
        { header, headerCopy, cost, discount, list } = columnStrings,
        columnBorder = name !== 'hunt' ? '2px solid #959595' : '',
        width = name !== 'choose' ? '170px' : '250px',
        columnClass = name === 'proYearly' || name === 'proMonthly' ?
          'sub-info-column-pro' : 'sub-info-column',
        buttonText = name === 'hunt' ? 'add to basic plan' : 'subscribe',
        { openModal } = props

      //get rid of hardcoded cost
      return (
        <div className={columnClass} style={{ borderRight: columnBorder, width }}>
          <div className='sub-info-banner'></div>
          <div style={{ borderBottom: '1px solid black', padding: '15px', height: '115px' }}>
            <div className='sub-info-header'>{header}</div>
            <div className='sub-info-copy'>{headerCopy}</div>
          </div>
          <div>
            {
              cost ? (
                <div className='sub-info-cost'>
                  {cost}
                </div>
              ) : (
                <div className='sub-info-selection'>
                  <input type='radio'
                    onChange={() => { setPlanDuration(7) }}
                    checked={planDuration === 7}></input><p>Yearly</p>
                  <input type='radio'
                    onChange={() => { setPlanDuration(8) }}
                    checked={planDuration === 8}></input><p>Monthly</p>
                </div>
              )
            }
            {
              name !== 'hunt' ? (
                <ul className='sub-info-list'>
                  {
                    list.map((entry, idx) => {
                      const displayVal = entry !== 1 && entry !== 0 ? entry : '',
                        entryClass = entry === 1 ? 'sub-info-checked' :
                          entry === 0 ? 'sub-info-x' : '',
                        centerText = name !== 'choose' ? 'center' : 'left'
                      return (
                        <li key={idx} style={{ textAlign: centerText }}>
                          <span className={entryClass}>{displayVal}</span>
                        </li>
                      )
                    })
                  }
                </ul>
              ) : (
                <div style={{ height: '355px', paddingTop: '20px', boxSizing: 'border-box' }}>
                  {
                    list.map((entry, idx) => {
                      if (!entry.img) {
                        return (<div key={`name${idx}`}
                          style={{
                            marginBottom: '5px',
                            fontSize: '14px',
                            paddingRight: '5px',
                            paddingLeft: '5px',
                            textTransform: 'capitalize'
                          }}>{entry}</div>)
                      } else {
                        return (<img key={idx} src={entry.img} style={{ marginBottom: '5px' }}></img>)
                      }
                    })
                  }
                </div>
              )
            }
          </div>
          <div className='sub-info-gutter'>
            {
              name === 'choose' ? null : name === 'basic' ?
                (<div>Subscribed</div>) : (
                  <button className='horizontal-center'
                    onClick={() => {
                      openModal({
                        payment: {
                          type: name === 'hunt' ? 8 : 4,
                          duration: name === 'hunt' ? 5 : planDuration
                        }
                      })
                    }}
                    style={{ margin: 0 }}>{buttonText}</button>
                )
            }
          </div>
        </div>
      )
    }
  return (
    <div className='sub-info-bg' onClick={e => { e.stopPropagation() }}>
      <div className='sub-info-modal'>
        {makeColumn('choose')}
        {makeColumn('basic')}
        {planDuration === 7 ? makeColumn('proYearly') : makeColumn('proMonthly')}
        {makeColumn('hunt')}
      </div>
      <div className='default-close sub-info-close' onClick={closeModal}></div>
    </div>
  )
}

const mapStateToProps = state => ({
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  openModal: data => dispatch(openModal(data)),
  closeModal: () => dispatch(closeModal())
})

export default connect(mapStateToProps, mapDispatchToProps)(SubInfo)
